import { Accordion, AccordionTab } from "primereact/accordion";
import { Toolbar } from "primereact/toolbar";
import { EmptyFilterPurchase, Filter, IFilterInvTsReport } from "./Filter";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { IPermissionProps } from "../../../models/Login";
import { Fetch } from "../../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { TimsheetsUploaded } from "./TimsheetsUploaded";
import { InvoiceUploaded } from "./InvoiceUploaded";

interface Iprops {
    setReload: (reload: boolean) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export interface InvoiceTimesheetReport {
    login_ID?: number,
    user_Name?: string,
    user_EmailID?: string,
    branchName?: string,
    company_Name?: string,
    temp_Inactive?: boolean,
    invoiceCount?: number,
    timesheetCount?: number,
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<InvoiceTimesheetReport>, loading: boolean });
    const [filters, setFilters] = useState<IFilterInvTsReport>(EmptyFilterPurchase);
    const [showTimesheetReport, setShowTimesheetReport] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [showInvoiceReport, setShowInvoiceReport] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [tableLoad, setTableLoad] = useState(false);
    const dt = useRef<any>(null);

    const onHideShowTimesheetReport = () => setShowTimesheetReport({ singleData: {}, open: false });
    const onHideShowInvoiceReport = () => setShowInvoiceReport({ singleData: {}, open: false });

    const rightToolbarTemplate = () => {
        return (
            <>
            </>
        );
    };

    const header = () => <p>Invoice And Timesheet Report</p>;

    const headerForInvoiceReport = () => <p>Invoice's Added</p>;

    const headerForTimesheetReport = () => <p>Timesheet's Added</p>;

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        const response = await Fetch("InvoiceTracking/invoiceReport", "GET", null, `filter=${JSON.stringify(filters)}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            console.log(data);
            setTableData({ tableData: data, loading: false });
        }
    };

    useEffect(() => {
        if(tableLoad){
        loadTableData();
        setTableLoad(false)
        }
    }, [filters]);

    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IFilterInvTsReport) => setFilters(filters)} onSearch={() => setTableLoad(true)}/>
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={() => <p>Total</p>} />
                <Column field="user_Name" header="Name" sortable style={{ minWidth: '10rem' }} />
                <Column field="company_Name" header="Company" sortable style={{ minWidth: '10rem' }} />
                <Column field="branchName" header="Branch" sortable style={{ minWidth: '10rem' }} />
                <Column field="invoiceCount" header="Invoice Count" sortable style={{ minWidth: '10rem' }} body={(rowData: InvoiceTimesheetReport) => <p onClick={() => rowData.invoiceCount !== 0 ? setShowInvoiceReport({ singleData: { filters: filters, login_ID: rowData.login_ID }, open: true }) : onHideShowInvoiceReport()} style={(rowData.invoiceCount === 0 ? { color: "black" } : { color: '#2196F3', textDecoration: "underline", cursor: "pointer" })}>{rowData.invoiceCount}</p>} footer={() => {
                    const invAmnt = tableData.tableData.reduce((sum, item) => sum + (item.invoiceCount || 0), 0);
                    return <span className="">{invAmnt}</span>;
                }} />
                <Column field="timesheetCount" header="Timesheet Count" sortable style={{ minWidth: '10rem' }} body={(rowData: InvoiceTimesheetReport) => <p onClick={() => rowData.timesheetCount !== 0 ? setShowTimesheetReport({ singleData: { filters: filters, login_ID: rowData.login_ID }, open: true }) : onHideShowTimesheetReport()} style={(rowData.timesheetCount === 0 ? { color: "black" } : { color: '#2196F3', textDecoration: "underline", cursor: "pointer" })}>{rowData.timesheetCount}</p>} footer={() => {
                    const invAmnt = tableData.tableData.reduce((sum, item) => sum + (item.timesheetCount || 0), 0);
                    return <span className="">{invAmnt}</span>;
                }} />
            </DataTable>
            <Dialog visible={showInvoiceReport.open} style={{ width: '80vw' }} header={headerForInvoiceReport} className="p-fluid" onHide={onHideShowInvoiceReport} draggable={false}>
                <InvoiceUploaded open={showInvoiceReport.open} filters={showInvoiceReport.singleData.filters} login_ID={showInvoiceReport.singleData.login_ID} toast={props.toast} />
            </Dialog>
            <Dialog visible={showTimesheetReport.open} style={{ width: '80vw' }} header={headerForTimesheetReport} className="p-fluid" onHide={onHideShowTimesheetReport} draggable={false}>
                <TimsheetsUploaded open={showTimesheetReport.open} filters={showTimesheetReport.singleData.filters} login_ID={showTimesheetReport.singleData.login_ID} toast={props.toast} />
            </Dialog>
        </>
    );
}